import { render, staticRenderFns } from "./VideoDrawer.vue?vue&type=template&id=3bd963aa"
import script from "./VideoDrawer.vue?vue&type=script&lang=js"
export * from "./VideoDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports